import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-i-live-with-dementia',
  templateUrl: './i-live-with-dementia.component.html',
  styleUrls: ['./i-live-with-dementia.component.css'],
})
export class ILiveWithDementiaComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
